const preview = {
  namespaced: true,
  state: {
    isShow:false,
    select:'pc',//pad , mb
    module:'index:index',//请求预览地址的参数
    path:'',//预览的路径
  },
  mutations: {
    SET_isShow(state, val) {
      state.isShow = val;
    },
    SET_select(state, val) {
      state.select = val;
    },
    SET_path(state, val) {
      state.path = val;
    },
    SET_module(state, val) {
      state.module = val;
    },



  },
  actions: {


  }

};


export default preview;



// WEBPACK FOOTER //
// ./src/vuex/modules/preview.js